import { createPopToastMsgForMarppleShop } from '../../../../../Util/F/Function/createPopToastMsgForMarppleShop.js';
import { updateLikeApiHelper } from './updateLikeApiHelper.js';

const popToastMsg = createPopToastMsgForMarppleShop();

/**
 * 마플샵 전용 update like
 * @see {updateLike}
 */
export const updateLikeMarppleShop = async (
  already_like,
  stores_product_id,
  has_toast_bottom_margin = false,
) => {
  popToastMsg(
    already_like ? T('mshop::좋아요 목록에서 삭제되었습니다.') : T('mshop::좋아요 목록에 추가되었습니다.'),
    already_like ? 'error' : 'like',
    { has_bottom_margin: has_toast_bottom_margin },
  );
  const ok = await updateLikeApiHelper.post(already_like, stores_product_id);
  if (!ok) await Promise.reject(Error('Not ok'));
};
